<!--
/*******************************************************************************
*@ 컴포넌트명   : MainContentsBfLogin.vue
*@ 컴포넌트설명 : 메인 본문 (로그인전)
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article class="contents">
    <!-- Quick Service -->
    <div
      class="service"
      v-if="siteCode == $config.SITECODE_OGCBD || siteCode == $config.SITECODE_OGHCM"
    >
      <div class="cont-tit">
        <h6>{{ /*빠른 서비스*/ $t("MMAIN-03-01-01-19") }}</h6>
      </div>
      <div class="box-normal" @click="goPage('1')">
        {{ /*PC를 위한 모바일 OTP 확인서*/ $t("MMAIN-03-01-01-20") }}
        <i class="icon icon-arrow-m-right" />
      </div>
    </div>
    <!-- First time guide -->
    <div class="time-guide">
      <div class="cont-tit">
        <h6>{{ /*첫 가이드*/ $t("MMAIN-03-01-01-21") }}</h6>
      </div>
      <div class="box-normal">
        <div class="box-normal-col" @click="goPage('2')">
          <i class="icon icon-time-guide01" />
          <span>{{ /*예금상품*/ $t("MMENU-0015") }}</span>
        </div>
        <div class="box-normal-col" @click="goPage('3')">
          <i class="icon icon-time-guide02" />
          <span>{{ /*간편 로그인*/ $t("MMAIN-03-01-01-05") }}</span>
        </div>
        <div class="box-normal-col" @click="goPage('4')">
          <i class="icon icon-time-guide03" />
          <span>{{ /*FAQ*/ $t("MMENU-0033") }}</span>
        </div>
      </div>
    </div>
    <!-- Help Desk -->
    <div class="help">
      <div class="cont-tit">
        <h6>{{ /*헬프데스크*/ $t("MMAIN-03-01-01-22") }}</h6>
      </div>
      <div class="box-normal">
        <div class="header">
          <div class="tit">{{ /*아이디/비밀번호 분실*/ $t("MMAIN-03-01-01-06") }}</div>
        </div>
        <div class="cont">
          <ul class="ulist ulist-type--bullet">
            <li>
              <p>{{ /*아이디 찾기 메뉴에서 계좌인증으로 찾을 수 있습니다.*/ $t("MMAIN-03-01-01-07") }}</p>
            </li>
            <li>
              <p>{{ /*비밀번호 변경 메뉴에서 계좌 인증과 OTP인증으로 변경하실 수 있습니다.*/ $t("MMAIN-03-01-01-09") }}</p>
            </li>
          </ul>
        </div>
        <div class="bottom">
          <div class="btn-area--bottom">
            <button
              class="btn sm outline"
              @click="goPage('5')"
            >{{ /*ID 찾기*/ $t("MMAIN-03-01-01-08") }}</button>
            <button
              class="btn sm outline"
              @click="goPage('6')"
            >{{ /*비밀번호 변경*/ $t("MMAIN-03-01-01-10") }}</button>
          </div>
        </div>
      </div>
    </div>
    <!-- DIV logo -->
    <div v-if="siteCode == $config.SITECODE_OGHCM" class="cont-img logo">
      <i class="icon img-DIV-logo"></i>
      <span class="v-hidden">Deposit insurance of Vietnam (DIV)</span>
    </div>
    <!--// DIV logo -->
  </article>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields(["siteCode"]),
  },
  data() {
    return {};
  },
  methods: {
    goPage(data) {
      let pageName;

      if (data == "1") {
        //mOTP 목록
        pageName = "authPCMotpStep1";
      } else if (data == "2") {
        //예금상품
        pageName = "depositList";
      } else if (data == "3") {
        //간편로그인
        pageName = "guideSimpleLogin";
      } else if (data == "4") {
        //FAQ
        pageName = "faq";
      } else if (data == "5") {
        //사용자ID조회
        pageName = "findId";
      } else if (data == "6") {
        //사용자암호변경
        pageName = "changePassword";
      }

      this.$emit("click", pageName);
    },
  },
};
</script>
